import { FC, useState } from 'react';
import { ParamsProps } from '../../../../../common/components/ParamsProvider';
import { fetchCampaignCategoryList } from '../../../network/campaignCategoryCrud';
import { useDataProvider } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types';
import { CampaignCategoryItem, CampaignCategoryListParam } from '../../../types/campaign-category';
import { useDispatch } from 'react-redux';
import CampaignCategoryList from './components/ConfigCampaignCategoryList';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { useIntl } from 'react-intl';

type CampaignCategoryListingPageProps = {} & ParamsProps;

const initialState: CampaignCategoryListParam = {
  limit: 5,
  page: 1,
  name: '',
};

const ConfigCampaignCategoryListingPage: FC<CampaignCategoryListingPageProps> = ({
  initialParams,
  onChangeQueryParams,
}) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  const [filterState, setFilterState] = useState<CampaignCategoryListParam>({
    ...initialState,
    name: initialParams?.name || '',
  });

  const [campaignCategoryList, setCampaignCategoryList] = useState<PaginateList<CampaignCategoryItem>>();
  const { isLoading, refreshData } = useDataProvider<PaginateList<CampaignCategoryItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await fetchCampaignCategoryList(filterState, dispatch);
      } catch (err) {}
    },
    setCampaignCategoryList,
    false,
  );

  return (
    <>
      <PruFilter
        title={Translation('configCampaignCategory.search')}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            style: { width: 250 },
            field: 'name',
            initialValue: filterState.name,
            displayName: Translation('configCampaignCategory.search.name'),
          },
        ]}
        onChangeFilter={(data) =>
          setFilterState({
            ...filterState,
            name: data.name,
          })
        }
        fetchData={refreshData}
      />
      <CampaignCategoryList
        isLoading={isLoading}
        campaignCategoryList={campaignCategoryList}
        onRefresh={refreshData}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
      />
    </>
  );
};

export default ConfigCampaignCategoryListingPage;
